import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DeleteButton from 'Components/ComponentLibrary/Atoms/Buttons/DeleteButton';
import { dispatchModalItemDeletedRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 0),
  },
}));


export default function WizardStepDeleteButton({
  className,
  dialogProps,
  onDelete,
  onDeleteSuccess,
}) {
  const classes = useStyles();
  const { displayErrorMessage } = useSnackbarContext();

  const {
    title,
    message,
    cancelLabel,
    confirmLabel,
  } = dialogProps || {};

  const {
    dialogOpen,
    loading,
    handleSubmit,
    handleOpen,
    handleClose,
  } = useConfirmationDialogState({
    onSubmit: onDelete,
  });

  async function handleConfirm() {
    try {
      const response = await handleSubmit();
      dispatchModalItemDeletedRefresh();
      return onDeleteSuccess(response);
    } catch (err) {
      displayErrorMessage(err, err?.errors || 'Failed to remove item.');
    }

    return undefined;
  }

  return (
    <div className={classNames(classes.root, className)} test="wizard-step-delete">
      <DeleteButton
        onClick={handleOpen}
      />
      {dialogOpen && (
      <NewDialog
        title={title}
        message={message}
        cancelLabel={cancelLabel}
        confirmLabel={confirmLabel}
        confirmButtonType="error"
        loading={loading}
        onConfirm={handleConfirm}
        onCancel={handleClose}
        onClose={handleClose}
        showCloseIcon={false}
      />
      )}
    </div>
  );
}

WizardStepDeleteButton.propTypes = {
  className: PropTypes.string,
  dialogProps: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
};

WizardStepDeleteButton.defaultProps = {
  className: null,
  dialogProps: null,
};
